import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';

export const getTariffs = createAsyncThunk('getTariffs', async () => {
  const response = await axios.get('/tariff/');
  return response.data;
});

export const addTariff = createAsyncThunk('addTariff', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/tariff/', data);
    dispatch(getTariffs());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateTariff = createAsyncThunk('updateTariff', async ({ id, data }, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.put(`/tariff/${id}/`, data);
    dispatch(getTariffs());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getTariff = createAsyncThunk('getTariff', async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`/tariff/${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteTariff = createAsyncThunk('deleteTariff', async (id, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/tariff/${id}/`);
    dispatch(getTariffs());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// charger provider tarifs

export const createChargerProviderTariffs = createAsyncThunk(
  'createChargerProviderTariffs',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/charger-provider-tariff/', data);
      dispatch(getTariffs());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getChargerProviderTariffs = createAsyncThunk('getChargerProviderTariffs', async (provider_id) => {
  const response = await axios.get('/charger-provider-tariff/', {
    params: {
      provider_id,
    },
  });
  return response.data;
});

// provider groups tariffs
export const createProviderGroupsTariffs = createAsyncThunk(
  'createProviderGroupsTariffs',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/provider-groups-tariff/', data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProviderGroupsTariffs = createAsyncThunk('getProviderGroupsTariffs', async (provider_group_id) => {
  const response = await axios.get('/provider-groups-tariff/', {
    params: {
      provider_group_id,
    },
  });
  return response.data;
});

// charger groups tariffs
export const createChargerGroupsTariffs = createAsyncThunk(
  'createChargerGroupsTariffs',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/charger-groups-tariff/', data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getChargerGroupsTariffs = createAsyncThunk('getChargerGroupsTariffs', async (charger_group_id) => {
  const response = await axios.get('/charger-groups-tariff/', {
    params: {
      charger_group_id,
    },
  });
  return response.data;
});

const tariffAdapter = createEntityAdapter({});

const tariffSlice = createSlice({
  name: 'tariffs',
  initialState: tariffAdapter.getInitialState({
    providerGroupsTariffs: [],
    chargerGroupsTariffs: [],
    chargerProviderTariffs: [],
    tariffs: [],
    isLoading: false,
    isSubmitting: false,
    loading: false,
    currentTariff: {},
  }),
  reducers: {
    resetTariffs: (state) => {
      state.providerGroupsTariffs = [];
      state.chargerGroupsTariffs = [];
      state.chargerProviderTariffs = [];
    },
  },
  extraReducers: {
    [getTariffs.pending]: (state) => {
      state.loading = true;
    },
    [getTariffs.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.tariffs = data;
      state.loading = false;
    },
    [getTariffs.rejected]: (state) => {
      state.loading = false;
    },
    // ----------------------------
    [addTariff.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addTariff.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addTariff.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ----------------------------
    [updateTariff.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateTariff.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateTariff.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ----------------------------
    [deleteTariff.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteTariff.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteTariff.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ----------------------------
    [getTariff.pending]: (state) => {
      state.loading = true;
    },
    [getTariff.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.currentTariff = data;
      state.loading = false;
    },
    [getTariff.rejected]: (state) => {
      state.loading = false;
    },

    [createChargerProviderTariffs.pending]: (state) => {
      state.loading = true;
    },
    [createChargerProviderTariffs.fulfilled]: (state) => {
      state.loading = false;
    },
    [createChargerProviderTariffs.rejected]: (state) => {
      state.loading = false;
    },
    [getChargerProviderTariffs.pending]: (state) => {
      state.loading = true;
    },
    [getChargerProviderTariffs.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.chargerProviderTariffs = data;
      state.loading = false;
    },
    [getChargerProviderTariffs.rejected]: (state) => {
      state.loading = false;
    },
    [createProviderGroupsTariffs.pending]: (state) => {
      state.loading = true;
    },
    [createProviderGroupsTariffs.fulfilled]: (state) => {
      state.loading = false;
    },
    [createProviderGroupsTariffs.rejected]: (state) => {
      state.loading = false;
    },
    [getProviderGroupsTariffs.pending]: (state) => {
      state.loading = true;
    },
    [getProviderGroupsTariffs.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.providerGroupsTariffs = data;
      state.loading = false;
    },
    [getProviderGroupsTariffs.rejected]: (state) => {
      state.loading = false;
    },
    [createChargerGroupsTariffs.pending]: (state) => {
      state.loading = true;
    },
    [createChargerGroupsTariffs.fulfilled]: (state) => {
      state.loading = false;
    },
    [createChargerGroupsTariffs.rejected]: (state) => {
      state.loading = false;
    },
    [getChargerGroupsTariffs.pending]: (state) => {
      state.loading = true;
    },
    [getChargerGroupsTariffs.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.chargerGroupsTariffs = data;
      state.loading = false;
    },
    [getChargerGroupsTariffs.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { resetTariffs } = tariffSlice.actions;

export default tariffSlice.reducer;
